// extracted by mini-css-extract-plugin
module.exports = {"SWithWatchList":"withWatchlist_SWithWatchList__MJxmU","SWithWatchlistButton":"withWatchlist_SWithWatchlistButton__wQWDt","SWatchlistSvg":"withWatchlist_SWatchlistSvg__Q90ZI"};